export default __webpack_public_path__ + "img/2f9e833640de35d201799b0785795355.svg";